// 三方库/框架
import to from "await-to-js";
// 公共方法
import { getJDISiteKeys } from "@/utils/multiSite";
// 接口
import { Country, Language } from "@/apis/address/address.interface";
import { getCountryInfoList } from "@/apis/address/address.api";

export interface CountrySetParams {
  fromCountry?: string;
  toCountry: string;
  shouldRefresh?: boolean;
}

export const defaultLanguageList = [
  {
    displayName: "EN",
    languageCode: "en_GB",
    code: "en_GB",
    name: "English - EN",
    displayText: "English - EN",
    type: 1,
  },
  // {
  //   displayName: "ZH",
  //   languageCode: "zh_CN",
  //   code: "zh_CN",
  //   name: "中文(简体) - ZH",
  //   displayText: "中文(简体) - ZH",
  //   type: 2,
  // },
  // {
  //   displayName: "繁体",
  //   languageCode: "zh_TW",
  //   code: "zh_TW",
  //   name: "中文(繁体) - TW",
  //   displayText: "中文(繁体) - TW",
  //   type: 3,
  // },
  // {
  //   displayName: "NL",
  //   languageCode: "nl_NL",
  //   code: "nl_NL",
  //   name: "Nederlands - NL",
  //   displayText: "Nederlands - NL",
  //   type: 4,
  // },
  // {
  //   displayName: "DE",
  //   languageCode: "de_DE",
  //   code: "de_DE",
  //   name: "Deutsch - DE",
  //   displayText: "Nederlands - NL",
  //   type: 5,
  // },
  // {
  //   displayName: "FR",
  //   languageCode: "fr_FR",
  //   code: "fr_FR",
  //   name: "Français - FR",
  //   displayText: "Français - FR",
  //   type: 6,
  // }
] as Language[];

/**
 * 查询全局国家列表数据并处理当前国家信息
 * @param options 选项参数
 * @returns 包含国家列表和当前国家信息的对象
 */
export const queryGlobalCountriesData = async (options?: {
  value?: string;  // 指定的国家代码
}): Promise<{
  countryList: Country[];  // 国家列表
  currentCountry: Country | null;  // 当前选中的国家
  currentCountryCode: string;  // 当前选中的国家代码
  hasPermission: boolean; // 是否有多站点权限
}> => {
  // 当前国家代码
  const currentCountryCode = options?.value || getJDISiteKeys()?.["JDI-Country"];
  const whilelistCountryCode = ["GB"];
  try {

    let countryList: Country[] = [];

    const [, result] = await to(getCountryInfoList({}));
    const { countryInfoList = [], hasPermission } = result?.data || {};

    if (hasPermission) {
      countryList = countryInfoList && Array.isArray(countryInfoList) && countryInfoList.length > 0 
      ? countryInfoList 
      : [];
    } else {
      const [, countryData] = await to(getCountryInfoList({ countryCode: currentCountryCode }));
      countryList = countryData?.data?.countryInfoList && Array.isArray(countryData?.data?.countryInfoList) && countryData?.data?.countryInfoList.length > 0 
      ? countryData?.data?.countryInfoList 
      : [];
    }

    const currentCountry: Country | null = countryList?.find((country: Country) => country?.countryCode === currentCountryCode) || null;
    
    return {
      countryList,
      currentCountry: currentCountry as Country,
      currentCountryCode,
      hasPermission: hasPermission || currentCountryCode === "GB"
    };
  } catch (error) {
    console.error("获取国家数据异常:", error);
    // 发生异常时返回默认值
    return {
      countryList: [],
      currentCountry: null,
      currentCountryCode: "",
      hasPermission: whilelistCountryCode.includes(currentCountryCode)
    };
  }
};
